import { apiGet, FetchResponse } from "fetchApi";
import { IService } from "reducers/realestates";
import { TPaginationActionData } from "utils/paginationStore";

export const fetchServicesAdapter = async (
    params?: Record<string, unknown>
): Promise<FetchResponse<TPaginationActionData<IService>>> => {
    return apiGet<TPaginationActionData<IService>>("/services/", { params });
};